<!-- eslint-disable no-irregular-whitespace -->
<template>
    <div class="container">
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                <h1 class="title">Mentions légales</h1>
                </div>
            </div>
        </section>
        <div class="box">
            <div class="space-under">
                <h2 class="subtitle">Nom d'entreprise</h2>
                <div class="content">Arewal</div>
            </div>
            <div class="space-under">
                <h2 class="subtitle">Adresse</h2>
                <div class="content">Rue des Marais 11, 5300 Andenne</div>
            </div>
            <div class="space-under">
                <h2 class="subtitle">Coordonnées</h2>
                <div class="content">info@arewal.be</div>
            </div>
            <div class="space-under">
                <h2 class="subtitle">Numéro d'entreprise</h2>
                <div class="content">0627.818.345</div>
            </div>
            <div class="space-under">
                <h2 class="subtitle">Numéro de TVA</h2>
                <div class="content">BE.0627.818.345</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style>
.content {
    font-size: large;
    font-weight: 500;
}
</style>